/**
 * The providers the Databox needs on the nav page. The canvas gets them from the SQL IDE, but a
 * standalone route has no fabric, no connection specs and no orchestration JWT of its own.
 * `DataboxConnectionSession` restores connection browsing (`listDatabases / listSchemas /
 * listTables / listDirectory`) — the SQL IDE's ExecutionService owns that context on the canvas.
 */
import MainVerticalAppWrapper from '@common/VerticalApps/context/MainVerticalAppWrapper';

import { DataboxConnectionSession } from './DataboxConnectionSession';

import type { ReactNode } from 'react';

export function DataboxProviders({ children }: { readonly children: ReactNode }) {
  return (
    <MainVerticalAppWrapper>
      <DataboxConnectionSession>{children}</DataboxConnectionSession>
    </MainVerticalAppWrapper>
  );
}
